import Modal from '@/components/common/Modal.vue'
import Toast from '@/components/common/Toast.vue'
import NavHeader from '@/components/header/NavHeader.vue'
import Footer from '@/components/footer/Footer.vue'
import Container from '@/components/common/Container.vue'
import LoadMore from '@/components/common/LoadMore.vue'

var GlobalComponent = {} // 定义插件对象
GlobalComponent.install = function (Vue) {
	Vue.component('NavHeader', NavHeader)
	Vue.component('Footer', Footer)
	Vue.component('Container', Container)
	Vue.component('LoadMore', LoadMore)
if(!Vue.prototype.$Modal){
	let ModalEl = Vue.extend(Modal) 

	let vm = new ModalEl() 

	let tpl = vm.$mount().$el
	document.body.appendChild(tpl)
	//暴露全局方法
	Vue.prototype.$Modal = { 
		alert:vm.alert,
		confirm:vm.confirm
	}
 }
if (!Vue.prototype.$Toast) {
	let ToastEl = Vue.extend(Toast)
	let vm = new ToastEl() 

	let tpl = vm.$mount().$el
	document.body.appendChild(tpl)

	//暴露全局方法
	Vue.prototype.$Toast = { 
		show:vm.show,
		loading:vm.loading
	}
 }
 
}
export default GlobalComponent; 